import React from 'react';
import { withRouter, Route } from 'react-router-dom';
import Faqs from '../components/Faqs';
import { Header, Footer } from '../components';
import { NoticeDetail } from '../screens';

const Layout = (props) => {
	const { url } = props.match;
	return (
	  <div>
	    <Header />
	    <Route path={`${url}/faqs/:sectionId`} component={Faqs}/>
	    <Route path={`${url}/avisos/:slug`} component={NoticeDetail} />
	    {props.children}
	    <Footer style={props.footerStyle} />
	  </div>
	)
};

export default withRouter(Layout);



// WEBPACK FOOTER //
// ./src/screens/Layout.js